<div class="site-text">
    <p class="text">
        Die folgende Liste soll Ihnen helfen, möglichst schnell eine Antwort oder den richtigen Ansprechpartner für Ihr Anliegen zu finden.
    </p>
    <p class="title">
        Meine Organisation ist nicht im Verzeichnis aufgeführt.
    </p>
    <p class="text">
        eDirectory.ch führt in der Schweiz domizilierte Unternehmen und Organisationen auf, die E-Rechnungen mit Geschäftspartnern über einen bei eDirectory teilnehmenden E-Invoicing Service Provider austauschen und diesem das Recht zur Publikation in eDirectory erteilt haben. Bei Fragen dazu, wenden Sie sich an Ihren E-Invoicing Service Provider.
    </p>
    <p class="text">
        Rechnungssteller, die elektronische Rechnungen an eBill-Empfänger zustellen, können über die entsprechenden eBill-Funktionen bei den E-Banking-Applikationen der Schweizer Banken gefunden werden. Bei Fragen dazu, wenden Sie sich an Ihren eBill-Netzwerkpartner.
        <br>
        Weitere Infos unter <a href="https://www.ebill.ch" target="_blank">www.ebill.ch</a>
    </p>
    <p div class="title">
        Die Angaben zu meiner Organisation sind nicht korrekt.
    </p>
    <p class="text">
        Informieren Sie Ihren E-Invoicing-Service Provider, damit er die Daten anpassen kann.
    </p>
    <p class="title">
        Als E-Invoicing Service Provider möchte ich meine Kunden auch auf eDirectory.ch führen.
    </p>
    <p class="text">
        Wenn Sie als E-Invoicing Service Provider in der Schweiz domizilierten Unternehmen und Organisationen E-Invoicing Dienstleistungen anbieten und Ihre Kunden auf eDirectory publizieren möchten, melden Sie Ihr Interesse bei PostFinance <a href="mailto:billing-solutions@postfinance.ch?subject=eDirectory">(billing-solutions@postfinance.ch)</a>. Wir werden Sie schnellstmöglich kontaktieren.
    </p>
</div>
